import { lazy } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CacheBuster from 'react-cache-buster';
import { ToastContainer } from 'react-toastify';

import { AppContextProvider } from '#/context';
import { useSentry, useSetupAxios } from '#/services';
import { version } from '../package.json';
const LeadPath = lazy(() => import('./pages/lead-path/components/LeadPath'));

function App() {
  const queryClient = new QueryClient();

  const isCacheBusterEnable = !!Number(import.meta.env.VITE_CACHE_BUSTER);

  useSetupAxios();
  useSentry();

  return (
    <QueryClientProvider client={queryClient}>
      <AppContextProvider>
        <CacheBuster currentVersion={version} isEnabled={isCacheBusterEnable} metaFileDirectory={'/lead-path-widget'}>
          <LeadPath />
        </CacheBuster>
      </AppContextProvider>
      <ToastContainer />
    </QueryClientProvider>
  );
}

export default App;
